import React from 'react';
import {Button, Modal} from "antd";
import {connect} from "react-redux";
import {logout} from "../../actions/ui";

class SignOutButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogVisible: false
    }
  }

  handleShow = () => {
    this.setState({
      dialogVisible: true
    });
  };

  handleOk = () => {
    this.setState({
      dialogVisible: false
    });
    this.props.onLogout && this.props.onLogout();
  };

  handleCancel = () => {
    this.setState({
      dialogVisible: false
    });
  };

  render() {
    return (
      <React.Fragment>
        <Button icon='user' onClick={this.handleShow} className='sign-out'>
          <span className='hidden inline visible-sm'>Sign Out</span>
        </Button>
        <Modal
          title='Sign Out'
          visible={this.state.dialogVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          Are you sure you want to sign out?
        </Modal>
      </React.Fragment>
    );
  }
}

SignOutButton.propTypes = {};

export default connect(
  null,
  (dispatch, props) => ({
    onLogout: () => dispatch(logout())
  })
)(SignOutButton);


// WEBPACK FOOTER //
// ./src/components/Boilerplate/SignOutButton.js